import React from "react";
import {
  FaCube,
  FaExchangeAlt,
  FaWallet,
  FaCoins
} from "react-icons/fa";

function NFTMinting() {
  return (
    <>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Functionalities of NFT Marketplace
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaCube size={35} />
                  </div>
                  <h4>NFT Minting</h4>
                  <p>
                    Users can create and mint their own NFTs directly on the
                    platform. This functionality allows creators to upload their
                    digital assets, set attributes, and establish ownership
                    rights through customizable smart contracts.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaExchangeAlt size={35} />
                  </div>
                  <h4>Listing and Trading</h4>
                  <p>
                    The marketplace facilitates the listing and trading of NFTs,
                    providing users with an easy way to buy, sell, or auction
                    their digital assets. Sellers can create listings that
                    include descriptions, images, and pricing details, while
                    buyers can browse through various categories, filter
                    results, and place bids or make purchases.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaWallet size={35} />
                  </div>
                  <h4>Wallet Integration</h4>
                  <p>
                    Seamless wallet integration is crucial for managing digital
                    assets. The marketplace should support multiple
                    cryptocurrency wallets, allowing users to connect their
                    preferred wallet for storing, sending, and receiving NFTs
                    and cryptocurrencies.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaCoins size={35} />
                  </div>
                  <h4>Royalties & Creator Earnings</h4>
                  <p>
                    An essential feature of NFT marketplaces is the ability to
                    implement royalty systems that ensure creators earn a
                    percentage from secondary sales of their NFTs. This
                    functionality allows artists and creators to benefit
                    financially as their work appreciates in value, promoting a
                    sustainable ecosystem for digital artists.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTMinting;